"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Thumbnail;

var _react = _interopRequireWildcard(require("react"));

var _useClassBuilder = _interopRequireDefault(require("../../hooks/useClassBuilder"));

var _useStyleBuilder = _interopRequireDefault(require("../../hooks/useStyleBuilder"));

var _useRandomId = _interopRequireDefault(require("../../hooks/useRandomId"));

var _badge = _interopRequireDefault(require("../badge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*---------------------------------------------*/
var BASE_CLASS = "lth-c-thumbnails__thumbnail";
/*---------------------------------------------*/

function Thumbnail(props) {
  function onChange(e) {
    props.onSelected && props.onSelected(props.value);
  }

  var classes = (0, _useClassBuilder.default)(props, BASE_CLASS);
  var style = (0, _useStyleBuilder.default)(props);
  var componentId = (0, _useRandomId.default)();
  var ref = (0, _react.useRef)(null);
  var inputProps = {
    type: "radio",
    value: props.value,
    name: props.inputName,
    checked: props.selected,
    disabled: props.disabled,
    onChange: onChange
  };
  var handlers = {
    onMouseEnter: props.onMouseEnter && function () {
      return props.onMouseEnter(props.value);
    },
    onMouseLeave: props.onMouseLeave && function () {
      return props.onMouseLeave(props.value);
    }
  };
  var imgSource = props.img;
  var imgSelectedSource = props.imgSelected || imgSource;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: classes,
    style: style
  }, handlers, {
    key: props.key
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: componentId
  }, /*#__PURE__*/_react.default.createElement("input", _extends({
    id: componentId,
    className: BASE_CLASS + '__input'
  }, inputProps, {
    ref: ref
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: BASE_CLASS + '__control'
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: BASE_CLASS + '__control--normal',
    src: imgSource,
    alt: props.alt || props.key,
    key: "normal"
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: BASE_CLASS + '__control--selected',
    src: imgSelectedSource,
    alt: props.alt || props.key,
    key: "selected"
  }))), props.badge ? /*#__PURE__*/_react.default.createElement(_badge.default, {
    label: props.badge,
    textColor: "var(--color-neutral-white)",
    backgroundColor: "#9060F0"
  }) : null);
}
/*---------------------------------------------*/